import React, {useState, useEffect, useMemo, useRef} from "react";
import Menu from "../../../../components/layout/menu/index";
import '../../../../../src/index.css';
import 'simplebar-react/dist/simplebar.min.css';
import DownloadDocumentButton from "../../../../components/shared/downloadDocument";
import DateSingleFilterButton from "../../../../components/filters/dateSingleFilterButton";
import DateFilterButton from "../../../../components/filters/dateFilterButton";
import TimeSlotSelector from "../../../../components/appointment/timeSlotSelector";
import DynamicTable from "../../../../components/tables/oc/provider/dynamicTable";
import ModalAlertWarning from "../../../../components/shared/modals/modalAlertWarning";
import ModalSuccess from "../../../../components/shared/modals/modalSuccess";
import RefusedAppointment from "../../../../components/shared/modals/appointment/refusedAppointment";
import FilterInput from "../../../../components/filters/filterInput";
import {getSchedulesWithAppointments, getUnconfirmedAppointments, getScheduledAppointments, downloadExcelAppointments, updateAppointmentStatus, updateDeliveryStatus} from "../../../../client/appointment/index"
import PdfViewerModal from "../../../../components/pdfViewer";
import { UpdatePdfOC } from "../../../../client/purchaseOrder";

export default function AppointmentAdmin() {

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split('T')[0]; 
  });
  
  
  const [selectedTime, setSelectedTime] = useState("");
  const [availableTimeSlots, setAvailableTimeSlots] = useState([]);
  const [slotAvailability, setSlotAvailability] = useState({});
  const [loadingSchedules, setLoadingSchedules] = useState(false);
  const [loadingUnconfirmed, setLoadingUnconfirmed] = useState(false);
  const [dateDisplay, setDateDisplay] = useState("");

  const [unconfirmedAppointments, setUnconfirmedAppointments] = useState([]);
  const [filteredUnconfirmedAppointments, setFilteredUnconfirmedAppointments] = useState([]);
  
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const [showRefusedModal, setShowRefusedModal] = useState(false);
  const [appointmentToRefuse, setAppointmentToRefuse] = useState(null);

  const [expandedOrder, setExpandedOrder] = useState(null);
  const [expandedPosition, setExpandedPosition] = useState(null);
  const contentRefs = useRef({});
  const positionContentRefs = useRef({});

  const [confirmedAppointments, setConfirmedAppointments] = useState([]);
  const [refusedAppointments, setRefusedAppointments] = useState([]);

  const [pdfFile, setPdfFile] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [pdfError, setPdfError] = useState(false);

  const [confirmedPositions, setConfirmedPositions] = useState([]);
  const [refusedPositions, setRefusedPositions] = useState([]);

  // excel
  const [excelFilters, setExcelFilters] = useState({
    startDate: "",
    endDate: ""
  })
  //lista citas confirmadas

  const [scheduledAppointments, setScheduledAppointments] = useState([]);
  const [loadingScheduled, setLoadingScheduled] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

const [downloadingExcel, setDownloadingExcel] = useState(false);

const [markingDelivery, setMarkingDelivery] = useState(false);
const [processingPositionId, setProcessingPositionId] = useState(null);

const [showErrorModal, setShowErrorModal] = useState(false);
const [errorMessage, setErrorMessage] = useState("");

const [confirmingAppointment, setConfirmingAppointment] = useState(false);
const [refusingAppointment, setRefusingAppointment] = useState(false);

  const handleExcelDateRangeChange = (dates) => {
    setExcelFilters({
      startDate: dates.startDate || "",
      endDate: dates.endDate || ""
    });
  };
  
const handleMarkAsAttended = async (positionId, appointmentId) => {
  setProcessingPositionId(positionId);
  setMarkingDelivery(true);
  try {
    const response = await updateDeliveryStatus(positionId, true, appointmentId);
    
    if (response.data && response.data.message) {
      const updatedAppointments = scheduledAppointments.map(appointment => {
        if (appointment.positionId === positionId && appointment.appointmentId === appointmentId) {
          return {
            ...appointment,
            delivered: true
          };
        }
        return appointment;
      });
      
      setScheduledAppointments(updatedAppointments);
      
      setSuccessMessage(response.data.message || "Se marcó como entregado exitosamente.");
      setShowSuccessModal(true);
      
    }
    
  } catch (error) {
    console.error('Error al marcar como entregado:', error);
    
    let errorMsg = "Error al marcar como entregado. Intente nuevamente.";
    
    if (error.response) {
      if (error.response.data && error.response.data.message) {
        errorMsg = error.response.data.message;
      } else {
        switch (error.response.status) {
          case 400:
            errorMsg = error.response.data?.message || "Datos inválidos para marcar como entregado.";
            break;
          case 404:
            errorMsg = "No se encontró la posición en ninguna cita.";
            break;
          case 500:
            errorMsg = "Error del servidor. Intente más tarde.";
            break;
          default:
            errorMsg = `Error ${error.response.status}: ${error.response.data?.message || "Error desconocido"}`;
        }
      }
    } else if (error.request) {
      errorMsg = "Error de conexión con el servidor.";
    }
    
    setErrorMessage(errorMsg);
    setShowErrorModal(true);
  } finally {
    setMarkingDelivery(false);
    setProcessingPositionId(null);
  }
};

const handleMarkAsNotAttended = async (positionId, appointmentId) => {
  setProcessingPositionId(positionId);
  setMarkingDelivery(true);
  try {
    const response = await updateDeliveryStatus(positionId, false, appointmentId);
    
    if (response.data && response.data.message) {
      const updatedAppointments = scheduledAppointments.map(appointment => {
        if (appointment.positionId === positionId && appointment.appointmentId === appointmentId) {
          return {
            ...appointment,
            delivered: false
          };
        }
        return appointment;
      });
      
      setScheduledAppointments(updatedAppointments);
      
      setSuccessMessage(response.data.message || "Se marcó como no entregado exitosamente.");
      setShowSuccessModal(true);
      
    }
    
  } catch (error) {
    console.error('Error al marcar como no entregado:', error);
    
    let errorMsg = "Error al marcar como no entregado. Intente nuevamente.";
    
    if (error.response) {
      if (error.response.data && error.response.data.message) {
        errorMsg = error.response.data.message;
      } else {
        switch (error.response.status) {
          case 400:
            errorMsg = error.response.data?.message || "Datos inválidos para marcar como no entregado.";
            break;
          case 404:
            errorMsg = "No se encontró la posición en ninguna cita.";
            break;
          case 500:
            errorMsg = "Error del servidor. Intente más tarde.";
            break;
          default:
            errorMsg = `Error ${error.response.status}: ${error.response.data?.message || "Error desconocido"}`;
        }
      }
    } else if (error.request) {
      errorMsg = "Error de conexión con el servidor.";
    }
    
    setErrorMessage(errorMsg);
    setShowErrorModal(true);
  } finally {
    setProcessingPositionId(null);
    setMarkingDelivery(false);
  }
};

const handleDownloadExcel = async () => {
  setDownloadingExcel(true);
  try {

    
    const response = await downloadExcelAppointments(
      '',           // searchTerm - vacío
      '',           // date - vacío  
      '',           // startTime - vacío
      '',           // endTime - vacío
      excelFilters.startDate || '', 
      excelFilters.endDate || ''    
    );

    const contentType = response.headers['content-type'] || '';
    
    if (contentType.includes('application/json')) {
      const text = await response.data.text();
      const jsonData = JSON.parse(text);
      
      if (jsonData.hasData === false) {
        setErrorMessage(jsonData.message || "No se encontraron citas agendadas con los filtros aplicados.");
        setShowErrorModal(true);
        setDownloadingExcel(false);
        return;
      }
      
      if (jsonData.message) {
        setErrorMessage(jsonData.message);
        setShowErrorModal(true);
        setDownloadingExcel(false);
        return;
      }
    }
    
    let fileName = 'Citas_agendadas';
    
    const contentDisposition = response.headers['content-disposition'];
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (filenameMatch && filenameMatch[1]) {
        fileName = filenameMatch[1].replace(/['"]/g, '');
      }
    }
    
    if (fileName === 'Citas_agendadas') {
      if (excelFilters.startDate && excelFilters.endDate) {
        const startFormatted = excelFilters.startDate.split('-').reverse().join('');
        const endFormatted = excelFilters.endDate.split('-').reverse().join('');
        fileName += `_${startFormatted}_a_${endFormatted}`;
      } else if (excelFilters.startDate) {
        const formattedDate = excelFilters.startDate.split('-').reverse().join('');
        fileName += `_${formattedDate}`;
      } else if (excelFilters.endDate) {
        const formattedDate = excelFilters.endDate.split('-').reverse().join('');
        fileName += `_${formattedDate}`;
      }
      
      fileName += `_${new Date().toISOString().slice(0, 10)}.xlsx`;
    }
    
    const blob = new Blob([response.data], {
      type: contentType || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    
    if (blob.size === 0) {
      setErrorMessage("No se pudo generar el archivo Excel.");
      setShowErrorModal(true);
      setDownloadingExcel(false);
      return;
    }
    
    const arrayBuffer = await blob.slice(0, 4).arrayBuffer();
    const headerBytes = new Uint8Array(arrayBuffer);
    
    const isExcelFile = headerBytes[0] === 0x50 && headerBytes[1] === 0x4B && 
                        headerBytes[2] === 0x03 && headerBytes[3] === 0x04;
    
    if (!isExcelFile) {
      const text = await blob.text();
      try {
        const jsonData = JSON.parse(text);
        if (jsonData.message) {
          setErrorMessage(jsonData.message);
          setShowErrorModal(true);
          setDownloadingExcel(false);
          return;
        }
      } catch (e) {
      }
      
      setErrorMessage("El archivo descargado no es un Excel válido.");
      setShowErrorModal(true);
      setDownloadingExcel(false);
      return;
    }
    
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
    
  } catch (error) {
    console.error('Error al descargar Excel:', error);
    
    if (error.response && error.response.data instanceof Blob) {
      try {
        const errorText = await error.response.data.text();
        const errorJson = JSON.parse(errorText);
        if (errorJson.message) {
          setErrorMessage(errorJson.message);
          setShowErrorModal(true);
          setDownloadingExcel(false);
          return;
        }
      } catch (e) {
      }
    }
    
    if (error.response) {
      switch (error.response.status) {
        case 400:
          setErrorMessage('Datos de fecha inválidos');
          break;
        case 404:
          setErrorMessage('No se encontraron datos con los filtros aplicados');
          break;
        case 500:
          setErrorMessage('Error del servidor. Intente más tarde.');
          break;
        default:
          setErrorMessage('Error al descargar el archivo. Intente nuevamente.');
      }
    } else if (error.request) {
      setErrorMessage('Error de conexión con el servidor.');
    } else {
      setErrorMessage('Error inesperado. Intente nuevamente.');
    }
    
    setShowErrorModal(true);
  } finally {
    setDownloadingExcel(false);
  }
};

  const fetchScheduledAppointments = async () => {

    
    setLoadingScheduled(true);
    try {
      let startTime = "", endTime = "";
      
      if (selectedTime) {
        [startTime, endTime] = selectedTime.split(' - ');
      }
      
      const response = await getScheduledAppointments(
        searchTerm,
        selectedDate,
        startTime,
        endTime,
        currentPage,
        recordsPerPage
      );
      
      
      if (response.data && response.data.data) {
        setScheduledAppointments(response.data.data);
        setTotalRecords(response.data.pagination.totalRecords);
        setTotalPages(response.data.pagination.totalPages);
        setRecordsPerPage(response.data.pagination.pageSize);
      } else {
        setScheduledAppointments([]);
        setTotalRecords(0);
        setTotalPages(1);
      }
    } catch (error) {
      console.error('Error al cargar citas agendadas:', error);
      setScheduledAppointments([]);
      setTotalRecords(0);
      setTotalPages(1);
    } finally {
      setLoadingScheduled(false);
    }
  };

  const transformScheduledAppointmentData = (apiData) => {
    return apiData.map(item => {
      const [startTime, endTime] = item.timeSlot.split(' - ');
      const [startHour, startMinute] = startTime.split(':');
      const [endHour, endMinute] = endTime.split(':');
      
      const startPeriod = parseInt(startHour) >= 12 ? 'PM' : 'AM';
      const endPeriod = parseInt(endHour) >= 12 ? 'PM' : 'AM';
      
      const formattedStartHour = parseInt(startHour) > 12 ? parseInt(startHour) - 12 : parseInt(startHour);
      const formattedEndHour = parseInt(endHour) > 12 ? parseInt(endHour) - 12 : parseInt(endHour);
      
      return {
        id: `${item.orderNumber}-${item.positionNumber}`, 
        positionId: item.positionId,
        appointmentId: item.appointmentId,
        codCita: item.appointmentCode,
        nroContacto: item.contactNumber,
        proveedor: item.supplierName,
        oc: item.orderNumber,
        pos: item.positionNumber,
        tipoEntrega: item.deliveryType,
        cantidad: item.quantity,
        fecha: item.date.split('-').reverse().join('/'), 
        hora: `${formattedStartHour}:${startMinute} ${startPeriod} - ${formattedEndHour}:${endMinute} ${endPeriod}`,
        ubicacion: item.centerName,
        entrego: () => handleMarkAsAttended(item.positionId, item.appointmentId), 
        noEntrego: () => handleMarkAsNotAttended(item.positionId, item.appointmentId),
        delivered: item.delivered
      };
    });
  };


  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
    setCurrentPage(1); 
  };
  
  useEffect(() => {
    fetchScheduledAppointments();
  }, [searchTerm, selectedDate, selectedTime, currentPage]);

  useEffect(() => {
    if (selectedDate || selectedTime) {
      setCurrentPage(1);
    }
  }, [selectedDate, selectedTime]);


const handlePositionAction = (positionId, action) => {
  
  if (action === 'confirm') {
    if (confirmedPositions.includes(positionId)) {
      setConfirmedPositions(prev => prev.filter(id => id !== positionId));
    } else {
      setConfirmedPositions(prev => [...prev, positionId]);
      setRefusedPositions(prev => prev.filter(id => id !== positionId));
    }
  } else if (action === 'refuse') {
    if (refusedPositions.includes(positionId)) {
      setRefusedPositions(prev => prev.filter(id => id !== positionId));
    } else {
      setRefusedPositions(prev => [...prev, positionId]);
      setConfirmedPositions(prev => prev.filter(id => id !== positionId));
    }
  }
  
};

const handleBulkPositionAction = (positionIds, action) => {
  
  const allPositionsConfirmed = positionIds.every(id => confirmedPositions.includes(id));
  const allPositionsRefused = positionIds.every(id => refusedPositions.includes(id));
  
  if (action === 'confirm') {
    if (allPositionsConfirmed) {
      setConfirmedPositions(prev => prev.filter(id => !positionIds.includes(id)));
    } else {
      setConfirmedPositions(prev => [...prev.filter(id => !positionIds.includes(id)), ...positionIds]);
      setRefusedPositions(prev => prev.filter(id => !positionIds.includes(id)));
    }
  } else if (action === 'refuse') {
    if (allPositionsRefused) {
      setRefusedPositions(prev => prev.filter(id => !positionIds.includes(id)));
    } else {
      setRefusedPositions(prev => [...prev.filter(id => !positionIds.includes(id)), ...positionIds]);
      setConfirmedPositions(prev => prev.filter(id => !positionIds.includes(id)));
    }
  }
  
};

const getAllPositionIdsFromAppointment = (appointment) => {
  const positionIds = [];
  appointment.purchaseOrders.forEach(order => {
    order.positions.forEach(pos => {
      positionIds.push(pos.positionId);
    });
  });
  return positionIds;
};

  const handleSelectTime = (time) => {

    if (time !== selectedTime) {
      setConfirmedPositions([]);
      setRefusedPositions([]);
      setConfirmedAppointments([]);
      setRefusedAppointments([]);
    }

    setSelectedTime(time);
  }

  const formatDateForDisplay = (dateString) => {
    if (!dateString) return '';
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  };

const handleViewDetails = async (purchaseOrderId) => {
  try {
    setLoadingPdf(true);
    setPdfError(false);
    
    const response = await UpdatePdfOC(purchaseOrderId);
    
    if (response.data && response.data.pdfUrl) {
      setPdfFile(response.data.pdfUrl);
      setShowPdfModal(true);
    } else {
      setPdfError(true);
      console.error("No se pudo obtener la URL del PDF");
    }
  } catch (error) {
    console.error("Error al cargar el PDF:", error);
    setPdfError(true);
  } finally {
    setLoadingPdf(false);
  }
};

  const fetchSchedulesForDate = async (date) => {
    if (!date) return;
    
    setLoadingSchedules(true);
    try {
      const response = await getSchedulesWithAppointments(date);
      
      if (response.data && response.data.schedules && response.data.schedules.length > 0) {
        const timeSlots = response.data.schedules.map(schedule => 
          `${schedule.startTime} - ${schedule.endTime}`
        );
        
        const availability = {};
        response.data.schedules.forEach(schedule => {
          const timeSlot = `${schedule.startTime} - ${schedule.endTime}`;
          availability[timeSlot] = schedule.blockSchedule ? 0 : schedule.queueSupplier;
        });
        
        setAvailableTimeSlots(timeSlots);
        setSlotAvailability(availability);
        setDateDisplay(formatDateForDisplay(date));

        if (timeSlots.length > 0 && !selectedTime) {
          const firstTimeSlot = timeSlots[0];
          setSelectedTime(firstTimeSlot);
        }
        
      } else {
        setAvailableTimeSlots([]);
        setSlotAvailability({});
        setSelectedTime("");
        setDateDisplay(formatDateForDisplay(date));
      }
    } catch (error) {
      console.error('Error al cargar horarios:', error);
      setAvailableTimeSlots([]);
      setSlotAvailability({});
      setSelectedTime("");
    } finally {
      setLoadingSchedules(false);
    }
  };

  const fetchUnconfirmedAppointments = async (date, startTime, endTime) => {
    setLoadingUnconfirmed(true);
    try {
      const response = await getUnconfirmedAppointments(date, startTime, endTime);
      
      if (response.data && response.data.appointments) {
        setUnconfirmedAppointments(response.data.appointments);
        
        let filtered = response.data.appointments;
        if (date) {
          filtered = filtered.filter(appointment => appointment.scheduleDate === date);
        }
        
        if (startTime && endTime) {
          filtered = filtered.filter(appointment => 
            appointment.startTime === startTime && appointment.endTime === endTime
          );
        }
        
        setFilteredUnconfirmedAppointments(filtered);
      } else {
        setUnconfirmedAppointments([]);
        setFilteredUnconfirmedAppointments([]);
      }
    } catch (error) {
      console.error('Error al cargar citas sin confirmar:', error);
      setUnconfirmedAppointments([]);
      setFilteredUnconfirmedAppointments([]);
    } finally {
      setLoadingUnconfirmed(false);
    }
  };

const transformPositionDataByOC = (purchaseOrder, appointment) => {
  const [startHour, startMinute] = appointment.startTime.split(':');
  const [endHour, endMinute] = appointment.endTime.split(':');
  const startPeriod = parseInt(startHour) >= 12 ? 'PM' : 'AM';
  const endPeriod = parseInt(endHour) >= 12 ? 'PM' : 'AM';
  
  const formattedStartHour = parseInt(startHour) > 12 ? parseInt(startHour) - 12 : parseInt(startHour);
  const formattedEndHour = parseInt(endHour) > 12 ? parseInt(endHour) - 12 : parseInt(endHour);
  
  return purchaseOrder.positions.map(position => ({
    id: position.positionId,
    positionId: position.positionId,
    proveedor: appointment.supplier?.name || " ",
    oc: `${purchaseOrder.purchaseOrderNumber}`,
    pos: `${position.positionNumber}`,
    tipoEntrega: position.deliveryType,
    cantidad: position.quantity,
    hora: `${formattedStartHour}:${startMinute} ${startPeriod} - ${formattedEndHour}:${endMinute} ${endPeriod}`,
    ubicacion: position.centerName || " ",
    detalles: () => handleViewDetails(purchaseOrder.purchaseOrderId),
    confirmarCita: () => handlePositionAction(position.positionId, 'confirm'),
    rechazarCita: () => handlePositionAction(position.positionId, 'refuse')
  }));
};

  useEffect(() => {
    fetchSchedulesForDate(selectedDate);
  }, []);


  const handleDateChange = (date) => {

    setConfirmedPositions([]);
    setRefusedPositions([]);
    setConfirmedAppointments([]);
    setRefusedAppointments([]);
    
    if (date) {
      setSelectedDate(date);
      setSelectedTime(""); 
      fetchSchedulesForDate(date);
    } else {
      const today = new Date().toISOString().split('T')[0];
      setSelectedDate(today);
      setSelectedTime(""); 
      fetchSchedulesForDate(today);
    }
  };

  useEffect(() => {
    if (selectedTime && selectedDate) {
      const [startTime, endTime] = selectedTime.split(' - ');
      fetchUnconfirmedAppointments(selectedDate, startTime, endTime);
    } else if (selectedDate && availableTimeSlots.length === 0) {
      setFilteredUnconfirmedAppointments([]);
    }
  }, [selectedTime, selectedDate]);

  
  useEffect(() => {
    if (availableTimeSlots.length > 0 && !selectedTime) {
      const firstTimeSlot = availableTimeSlots[0];
      setSelectedTime(firstTimeSlot);
    } else if (availableTimeSlots.length === 0) {
      setFilteredUnconfirmedAppointments([]);
      setSelectedTime("");
    }
  }, [availableTimeSlots]);
  
  const toggleOrder = (appointmentId) => {
    setExpandedOrder(expandedOrder === appointmentId ? null : appointmentId);
    if (expandedPosition !== null) {
      setExpandedPosition(null);
    }
  };

const togglePosition = (positionKey) => {
  setExpandedPosition(expandedPosition === positionKey ? null : positionKey);
};


const buildConfirmRequest = (appointment) => {

  const allPositionIds = appointment.purchaseOrders.flatMap(order => 
    order.positions.map(pos => pos.positionId)
  );
  
  const hasSelectedPositions = allPositionIds.some(id => 
    confirmedPositions.includes(id) || refusedPositions.includes(id)
  );
  
  if (!hasSelectedPositions) {
    return {
      confirm: true
    };
  }

  const allPositions = appointment.purchaseOrders.flatMap(order => 
    order.positions.map(pos => ({
      purchaseOrderPositionId: pos.positionId,
      confirm: confirmedPositions.includes(pos.positionId) ? true : false
    }))
  );

  const requestData = {
    confirm: true,
    positions: allPositions
  };

  return requestData;

};

const buildRefuseRequest = (refuseDescription = "") => {
  const requestData = {
    confirm: false,
    refuse_description: refuseDescription
  };

  return requestData;
};

const handleConfirmAppointment = async (appointment) => {
  setSelectedAppointment(appointment);
  
  setShowConfirmModal(true);
};

const handleRefuseAppointment = (appointment) => {
  setAppointmentToRefuse(appointment);
  setShowRefusedModal(true);
};

const handleRefuseFinal = async (refuseDescription = "") => {
  if (!appointmentToRefuse || refusingAppointment) return;
  
  setRefusingAppointment(true);

  try {
    
    const requestData = buildRefuseRequest(refuseDescription);
    
    const response = await updateAppointmentStatus(appointmentToRefuse.id, requestData);
    
    if (response.data && response.data.message) {
      setSuccessMessage(response.data.message);
      setShowSuccessModal(true);

      setRefusedAppointments(prev => [...prev, appointmentToRefuse.id]);
      setConfirmedAppointments(prev => prev.filter(id => id !== appointmentToRefuse.id));
      
      setFilteredUnconfirmedAppointments(prev => 
        prev.filter(appointment => appointment.id !== appointmentToRefuse.id)
      );
      
      const positionIds = getAllPositionIdsFromAppointment(appointmentToRefuse);
      setConfirmedPositions(prev => prev.filter(id => !positionIds.includes(id)));
      setRefusedPositions(prev => prev.filter(id => !positionIds.includes(id)));
      

      fetchScheduledAppointments();
    }
    
  } catch (error) {
    console.error("Error al rechazar la cita:", error);
    
    let errorMsg = "Error al rechazar la cita. Intente nuevamente.";
    
    if (error.response) {
      switch (error.response.status) {
        case 400:
          errorMsg = error.response.data?.message || "Datos inválidos para rechazar la cita.";
          break;
        case 404:
          errorMsg = "La cita no fue encontrada.";
          break;
        case 500:
          errorMsg = "Error del servidor. Por favor, intente más tarde.";
          break;
      }
    }
    
    setErrorMessage(errorMsg);
    setShowErrorModal(true);
  } finally {
    setRefusingAppointment(false);
    setShowRefusedModal(false);
    setAppointmentToRefuse(null);
    setShowSuccessModal(true);
  }
};

  const handleCancelRefuse = () => {
    setShowRefusedModal(false);
    setAppointmentToRefuse(null);
  };

const handleConfirmFinal = async () => {
  if (!selectedAppointment) return;
  setConfirmingAppointment(true);

  try {
    
    const requestData = buildConfirmRequest(selectedAppointment);
    
    const response = await updateAppointmentStatus(selectedAppointment.id, requestData);
    
    if (response.data && response.data.message) {
      setSuccessMessage(response.data.message);
      setShowSuccessModal(true);

      setConfirmedAppointments(prev => [...prev, selectedAppointment.id]);
      setRefusedAppointments(prev => prev.filter(id => id !== selectedAppointment.id));
      
      setFilteredUnconfirmedAppointments(prev => 
        prev.filter(appointment => appointment.id !== selectedAppointment.id)
      );
      
      const positionIds = getAllPositionIdsFromAppointment(selectedAppointment);
      setConfirmedPositions(prev => prev.filter(id => !positionIds.includes(id)));
      setRefusedPositions(prev => prev.filter(id => !positionIds.includes(id)));
      

      fetchScheduledAppointments();
    }
    
  } catch (error) {
    console.error("Error al confirmar la cita:", error);
    
    let errorMsg = "Error al confirmar la cita. Intente nuevamente.";
    
    if (error.response) {
      switch (error.response.status) {
        case 400:
          errorMsg = error.response.data?.message || "Datos inválidos para confirmar la cita.";
          break;
        case 404:
          errorMsg = "La cita no fue encontrada.";
          break;
        case 500:
          errorMsg = "Error del servidor. Por favor, intente más tarde.";
          break;
      }
    }
    
    setErrorMessage(errorMsg);
    setShowErrorModal(true);
  } finally {

    setConfirmingAppointment(false);
    setShowConfirmModal(false);
    setSelectedAppointment(null);
  }
};

  const handleCancelConfirm = () => {
    setShowConfirmModal(false);
    setSelectedAppointment(null);
  };

  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    setSuccessMessage("");
  };



  const tableConfig = {
    headers: [
      "Proveedor",
      "N° de OC",
      "Número de POS",
      "Tipo de entrega",
      "Cantidad registrada",
      "Horario",
      "Lugar de entrega",
      "Detalle",
      "Confirmar",
      "Rechazar"
    ],
    accessors: [
      "proveedor",
      "oc",
      "pos",
      "tipoEntrega",
      "cantidad",
      "hora",
      "ubicacion",
      "detalles",
      "confirmarCita",
      "rechazarCita"
    ],
    widths: [
      "150px", //proveedor
      "110px",  //nro oc 
      "100px", // n° de pos
      "110px", //tipo de entrega
      "140px", //cantidad registrada
      "100px", //hora
      "110px", //ubicacion final
      "90px", //detalle
      "90px", //confirmar
      "90px", //rechazar
    ]
  };

  const tableConfigAgendadas = {
    headers: [
      "Cód. Cita",
      "Proveedor",
      "N° de OC",
      "N° de POS",
      "Número de contacto",
      "Tipo de entrega",
      "Cantidad registrada",
      "Fecha",
      "Hora",
      "Lugar de entrega",
      "Entregó",
      "No entregó"
    ],
    accessors: [
      "codCita",
      "proveedor",
      "oc",
      "pos",
      "nroContacto",
      "tipoEntrega",
      "cantidad",
      "fecha",
      "hora",
      "ubicacion",
      "entrego",
      "noEntrego"
    ],
    widths: [
      "100px", //Cod cita
      "140px", //proveedor
      "142px", //n° de OC
      "126px", // n° de pos
      "130px", // número de contacto
      "141px", //tipo de entrega
      "141px", //cantidad registrada
      "138px", //fecha
      "167px", //hora
      "110px", //ubicacion final
      "90px", //asistió
      "90px", //no asistió
    ]
  };


  return (
    <div>
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300"/>
      <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} bg-[#F7F8F9] w-full z-50 min-h-screen`}>
        <div className="sm:pt-8 flex flex-col gap-4 pt-4 pb-10 px-[4%] sm:px-[3%]">
          <div className="flex flex-col w-full gap-4 p-5 bg-white rounded-lg shadow-lg">
            <h1 className="text-[#184A7D] font-itcbold md:text-[32px] text-2xl">
              Reporte de citas agendadas
            </h1>
            <div className="flex items-center gap-4">
              <DateFilterButton
                onDateRangeChange={handleExcelDateRangeChange}
                activeFilters={{
                  emissionDateFrom: excelFilters.startDate,
                  emissionDateTo: excelFilters.endDate,
                  createDateFrom: excelFilters.startDate,
                  createDateTo: excelFilters.endDate
                }}             
                title="Seleccionar rango de fechas para Excel"
                position="left-0"
              />

              <DownloadDocumentButton
                text="Descargar"
                onClick={handleDownloadExcel}
                loading={downloadingExcel} 
                disabled={!excelFilters.startDate || !excelFilters.endDate || downloadingExcel}  
              />
            </div>
          </div>

          <div className="flex flex-col w-full gap-3 p-5 bg-white rounded-lg shadow-lg">
            <div className="flex flex-col justify-between gap-2 sm:items-center sm:flex-row">
              <h2 className="text-[#6B7280] text-xl sm:text-2xl font-itcmedium">
                Horarios programados para el
                <span className="text-green">{' '} 
                  {dateDisplay || formatDateForDisplay(selectedDate)}
                </span>
              </h2>
              <DateSingleFilterButton
                onDateChange={handleDateChange}
                selectedDate={selectedDate}
                title="Seleccionar fecha"
                position="sm:right-0 "
              />
            </div>
            <h1 className="text-[#184A7D] font-itcbold md:text-[32px] text-2xl">
              Gestión de citas
            </h1>
  
            <>
            {loadingSchedules ? (
              <div className="flex justify-center py-4 col-span-full">
                <p className="text-gray font-itcmedium">Cargando horarios...</p>
              </div>
            ) : availableTimeSlots.length > 0 ? (
              <div className="grid items-center justify-center grid-cols-3 gap-3 mt-3 sm:grid-cols-5 md:grid-cols-6 lg:grid-cols-7 xl:grid-cols-8">
                <TimeSlotSelector
                  timeSlots={availableTimeSlots}
                  selectedTime={selectedTime}
                  onTimeSelect={handleSelectTime}
                  slotAvailability={slotAvailability}
                  tooltip={false}
                  classname="flex items-center justify-center"
                />
              </div>
            ) : (
              <div className="flex justify-center py-4 col-span-full">
                <p className="text-gray font-itcmedium">
                  No hay horarios disponibles para esta fecha
                </p>
              </div>
            )}
            </>
  
            <h2 className="text-[#6B7280] mt-2 text-2xl font-itcmedium">
              Citas por confirmar
            </h2>
  
            <div>
              {loadingUnconfirmed ? (
                <div className="flex justify-center py-4">
                  <p className="text-gray font-itcmedium">Cargando citas...</p>
                </div>
              ) : selectedTime && filteredUnconfirmedAppointments.length > 0 ? (
                filteredUnconfirmedAppointments.map((appointment) => {
                  return (
                    <div key={appointment.id}>
                      <button 
                        onClick={() => toggleOrder(appointment.id)}
                        className="flex flex-col sm:flex-row w-full mt-3 pb-1 items-center px-1 border-b-[1px] border-[#808080] justify-between gap-4 sm:gap-2"
                      >
                        <p className="text-[#52526C] font-itcmedium text-[14px]">
                          Cita "{appointment.code}" agendada para {appointment.supplier?.name} ({appointment.supplier?.code}) 
                        </p>
                        <div className="relative flex items-center justify-between w-full gap-4 sm:w-auto">
                          <div className="flex items-center justify-center w-full gap-3 sm:mr-8 sm:items-end sm:justify-end">
                            <button
                              className={`text-white font-rubikmedium text-[10px] flex items-center justify-center w-[82px] h-[23px] p-1 rounded-[5px] ${
                                expandedOrder === appointment.id ? 'bg-[#48B6E5]' : 'bg-[#A5A5A5]'
                              }`}     
                              onClick={(e) => {
                                e.stopPropagation(); 
                                handleConfirmAppointment(appointment);
                              }}
                              disabled={!expandedOrder}
                            >
                              Confirmar
                            </button>
                            <button
                              className={`text-white font-rubikmedium text-[10px] flex items-center justify-center w-[82px] h-[23px] p-1 rounded-[5px] ${
                                expandedOrder === appointment.id ? 'bg-[#CE242A]' : 'bg-[#A5A5A5]'
                              }`}  
                              onClick={(e) => {
                                e.stopPropagation(); 
                                handleRefuseAppointment(appointment);
                              }}
                              disabled={!expandedOrder}
                            >
                              Rechazar
                            </button>
                          </div>
                          <svg 
                            className={`absolute right-0 transition-transform duration-200 ${expandedOrder === appointment.id ? 'rotate-180' : ''}`} 
                            width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M4.55957 6.63501H13.4404C13.7125 6.63531 13.8531 6.96517 13.6641 7.16138L9.7793 11.0461C9.37869 11.4468 8.74158 11.472 8.31152 11.1213L8.22852 11.0461L4.34375 7.16138C4.14792 6.96555 4.28665 6.6354 4.55957 6.63501Z" fill="#292D32" stroke="#6B7280"/>
                          </svg>
                        </div>
                      </button>
  
                      <div
                        ref={el => contentRefs.current[appointment.id] = el}
                        className={`overflow-hidden transition-all duration-300 ease-in-out ${
                          expandedOrder === appointment.id ? 'max-h-[9999px]' : 'max-h-0'
                        }`}
                      > 
                        <div className="ml-8">
                          {appointment.purchaseOrders && appointment.purchaseOrders.length > 0 ? (
                            appointment.purchaseOrders.map((purchaseOrder, orderIndex) => {
                              const getPositionIdsForOC = (purchaseOrder) => {
                                return purchaseOrder.positions.map(pos => pos.positionId);
                              };
                              
                              const ocPositionIds = getPositionIdsForOC(purchaseOrder);
                              const allOcPositionsConfirmed = ocPositionIds.every(id => confirmedPositions.includes(id));
                              const allOcPositionsRefused = ocPositionIds.every(id => refusedPositions.includes(id));
                                                          
                              return (
                              <div key={`${appointment.id}-${purchaseOrder.purchaseOrderId}`}>
                                <button 
                                  onClick={() => togglePosition(`${appointment.id}-${purchaseOrder.purchaseOrderId}`)}
                                  className="flex w-full mt-2 pb-1 items-center px-1 border-b-[1px] border-[#808080] justify-between gap-2"
                                >
                                  <p className="text-[#52526C] font-itcmedium text-[14px]">
                                    OC {purchaseOrder.purchaseOrderNumber}
                                  </p>
                                  <div className="flex items-center gap-4">
                                    <div className="flex items-center gap-2">
                                      {/**confirmar */}
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation(); 
                                          handleBulkPositionAction(ocPositionIds, 'confirm');
                                        }}
                                      >
                                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M14 0C6.286 0 0 6.286 0 14C0 21.714 6.286 28 14 28C21.714 28 28 21.714 28 14C28 6.286 21.714 0 14 0ZM20.692 10.78L12.754 18.718C12.558 18.914 12.292 19.026 12.012 19.026C11.732 19.026 11.466 18.914 11.27 18.718L7.308 14.756C6.902 14.35 6.902 13.678 7.308 13.272C7.714 12.866 8.386 12.866 8.792 13.272L12.012 16.492L19.208 9.296C19.614 8.89 20.286 8.89 20.692 9.296C21.098 9.702 21.098 10.36 20.692 10.78Z"
                                           fill={allOcPositionsConfirmed ? "#43B02A" : "#D9D9D9"}/>
                                        </svg>
                                      </button>
                                      {/**rechazar */}
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation(); 
                                          handleBulkPositionAction(ocPositionIds, 'refuse');
                                        }}
                                      >
                                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M14 0C6.286 0 0 6.286 0 14C0 21.714 6.286 28 14 28C21.714 28 28 21.714 28 14C28 6.286 21.714 0 14 0ZM18.704 17.22C19.11 17.626 19.11 18.298 18.704 18.704C18.494 18.914 18.228 19.012 17.962 19.012C17.696 19.012 17.43 18.914 17.22 18.704L14 15.484L10.78 18.704C10.57 18.914 10.304 19.012 10.038 19.012C9.772 19.012 9.506 18.914 9.296 18.704C8.89 18.298 8.89 17.626 9.296 17.22L12.516 14L9.296 10.78C8.89 10.374 8.89 9.702 9.296 9.296C9.702 8.89 10.374 8.89 10.78 9.296L14 12.516L17.22 9.296C17.626 8.89 18.298 8.89 18.704 9.296C19.11 9.702 19.11 10.374 18.704 10.78L15.484 14L18.704 17.22Z"
                                            fill={allOcPositionsRefused ? "#E44949" : "#D9D9D9"}/>
                                        </svg>
                                      </button>   
                                    </div>
                                    <svg
                                      className={`transition-transform duration-200 ${expandedPosition === `${appointment.id}-${purchaseOrder.purchaseOrderId}` ? 'rotate-180' : ''}`} 
                                      width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path d="M4.55957 6.63501H13.4404C13.7125 6.63531 13.8531 6.96517 13.6641 7.16138L9.7793 11.0461C9.37869 11.4468 8.74158 11.472 8.31152 11.1213L8.22852 11.0461L4.34375 7.16138C4.14792 6.96555 4.28665 6.6354 4.55957 6.63501Z" fill="#292D32" stroke="#6B7280"/>
                                    </svg>
                                  </div>
                                </button>
                                <div
                                  ref={el => positionContentRefs.current[`${appointment.id}-${purchaseOrder.purchaseOrderId}`] = el}  
                                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                                    expandedPosition === `${appointment.id}-${purchaseOrder.purchaseOrderId}` ? 'max-h-[9999px]' : 'max-h-0'
                                  }`}
                                >
                                  <div className="py-2">
                                    <DynamicTable 
                                      data={transformPositionDataByOC(purchaseOrder, appointment)} 
                                      config={tableConfig}
                                      showRadioButtons={false}
                                      showPagination={false}
                                      collapsed={false}
                                      loading={false}
                                      isOCProvider={true}
                                      confirmedPositions={confirmedPositions}
                                      refusedPositions={refusedPositions}
                                      onAppointmentAction={handlePositionAction}
                                    />
                                  </div>
                                </div>
                              </div>
                              )
                          })
                          ) : (
                            <div className="flex items-center justify-center w-full p-4 text-center">
                              <p className="text-gray font-itcmedium">La cita no tiene posiciones.</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : selectedTime ? (
                <div className="flex items-center justify-center w-full p-4 text-center">
                  <p className="text-gray font-itcmedium">
                    No hay citas por confirmar para el horario seleccionado.
                  </p>
                </div>
              ) : (
                <div className="flex items-center justify-center w-full p-4 text-center">
                  <p className="text-gray font-itcmedium">
                    {availableTimeSlots.length > 0 
                      ? "Seleccione un horario para ver las citas por confirmar." 
                      : "No hay horarios disponibles para esta fecha."}
                  </p>
                </div>
              )}
            </div>
  
            <div className="flex flex-col mt-7">
              <div className="flex flex-col justify-between gap-2 mb-3 items-left sm:items-center sm:flex-row">
                <h2 className="text-[#6B7280] text-2xl font-itcmedium">
                  Citas agendadas
                </h2>
    
                <FilterInput
                  title="Buscar por proveedor:"
                  classname="w-[220px]"
                  horizontal="flex-col sm:flex-row items-start sm:items-center"
                  value={searchTerm}
                  placeholder="Escriba código o razón social"
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </div>
    
              <DynamicTable
                data={transformScheduledAppointmentData(scheduledAppointments)}
                config={tableConfigAgendadas}
                currentPage={currentPage}
                totalPages={totalPages}
                changePage={handlePageChange}
                recordsPerPage={recordsPerPage}
                totalRecords={totalRecords}
                showPagination={true}
                loading={loadingScheduled || markingDelivery}
                headerStyle="bg-blue text-white"
                headerFont="font-itcdemi"
              />
            </div>
          </div>

        {showPdfModal && (
          <PdfViewerModal
            pdfFile={pdfFile}
            onClose={() => {
              setShowPdfModal(false);
              setPdfFile(null);
              setPdfError(false);
            }}
          />
        )}

          <ModalAlertWarning
            showModalAlertWarning={showConfirmModal}  
            closeModal={handleCancelConfirm}
            error={selectedAppointment 
              ? `¿Está seguro que desea confirmar la cita del proveedor
               ${selectedAppointment.supplier?.name} para el ${formatDateForDisplay(selectedAppointment.scheduleDate)} en el horario de
                ${selectedAppointment.startTime} - ${selectedAppointment.endTime}?`
              : ""
            }
            accept={handleConfirmFinal}               
            color="#FFC000"  
            loading={confirmingAppointment}
          />

          <RefusedAppointment
            showModalAlertWarning={showRefusedModal}
            closeModal={handleCancelRefuse}
            title={`¿Está seguro de rechazar la cita del proveedor ${appointmentToRefuse?.supplier?.name}?`}
            accept={handleRefuseFinal}
          />
          

          <ModalSuccess
            showModalSuccess={showSuccessModal}
            closeModalSuccess={handleCloseSuccessModal}
            fill="green"
            text={successMessage}
          />

          <ModalAlertWarning
            showModalAlertWarning={showErrorModal}
            closeModal={() => {
              setShowErrorModal(false);
              setErrorMessage("");
            }}
            error={errorMessage}
            showAcceptButton={true}
          />
        </div>
      </div>
    </div>
  );
}